export const Filterparametros = (parametros = {})=>{
   
    return {
        mensaje_general_1: parametros['PAA: Mensaje general 1'],
        mensaje_general_2: parametros["PAA: Mensaje general 2"],
        mensaje_app_dte: parametros["PAA: Mensaje app dte"],
        mensaje_app_cxp: parametros["PAA: Mensaje app cxc"],
        mensaje_app_leasing: parametros["PAA: Mensaje app leasing"],
        is_app_cxc: parametros["PAA: App cxc Encendido"] == '1' ? true : false,
        is_app_dte: parametros["PAA: App dte Encendido"] == '1' ? true : false,
        is_app_lesing: parametros["PAA: App leasing Encendido"] == '1' ? true : false,
        // estado_cobranza: parametros["PAA: Estados de cobranza"],
        // limite_documento: parametros["PAA: Limite numero documentos"],
        // limite_dias_mora: parametros["PAA: Limite dias mora"],
        // limite_cuotas_proximas: parametros["PAA: Limite cuotas proximas"],
        mensaje_info_1: parametros["PAA: Mensaje informativo 1"],
        mensaje_info_2: parametros["PAA: Mensaje informativo 2"],
        mensaje_validacion_1: parametros["PAA: Mensaje validacion 1"],
        mensaje_validacion_2: parametros["PAA: Mensaje validacion 2"],
        mensaje_validacion_3: parametros["PAA: Mensaje validacion 3"],
        mensaje_validacion_4: parametros["PAA: Mensaje validacion 4"],
        mensaje_validacion_5: parametros["PAA: Mensaje validacion 5"],
        cuota_leasing_pendiente: parametros["PAA: Couta leasing pendiente"] == '1' ? true : false,
        etiqueta_aplicaciones: parametros["PAA: Etiqueta aplicaciones"],
    }
}